module.exports = __webpack_public_path__ + "static/media/spice_hero_mobile.59eb3059.jpg";